module.exports = __webpack_public_path__ + "static/media/iv_wallet.75d07ab5.svg";